import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getToken() {
  if (getParameterByName('ptToken')) {
    localStorage.setItem('ptToken', getParameterByName('ptToken'))
    return getParameterByName('ptToken');
  }
  else {
    if (localStorage.getItem('ptToken'))
      return `${localStorage.getItem('ptToken')}`;
    else
      return `${sessionStorage.getItem('ptToken')}`;
  }
}

@Injectable({ providedIn: 'root' })
export class ApiCommands {

  constructor(private httpClient: HttpClient) {
  }

  get<T>(url: string, auth = 'Basic'): Observable<T> {
    return this.httpClient.get<T>(url, this.getAuthHeaders(auth));
  }

  getNoAuth<T>(url: string): Observable<T> {
    return this.httpClient.get<T>(url);
  }

  post<T>(url: string, body: any, auth = 'Basic'): Observable<T> {
    return this.httpClient.post<T>(url, body, {
      headers: { 
        Authorization: auth, 
        timeout: '180000',
      },
      observe: 'body',
      reportProgress: true
    });
  }

  postObject<T>(url: string, body: any, auth = 'Basic'): Observable<T> {
    return this.httpClient.post<T>(url, body, {
      headers: { 
        'Content-Type': "application/json; charset=utf-8",
        // 'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
        Authorization: auth, 
        timeout: '180000' 
      },
      observe: 'body',
      reportProgress: true
    });
  }

  postNoAuth<T>(url: string, body: any, auth = ''): Observable<T> {
    return this.httpClient.post<T>(url, body, {
      observe: 'body',
      reportProgress: true
    });
  }

  put<T>(url: string, body: any, auth = 'Basic') {
    return this.httpClient.put<T>(url, body, this.getAuthHeaders(auth));
  }

  delete<T>(url: string, auth) {
    return this.httpClient.delete<T>(url, this.getAuthHeaders(auth));
  }

  upload<T>(url: string, body: any, auth = 'Basic'): Observable<T> {
    return this.httpClient.post<T>(url, body, {
      headers: { 
        Authorization: auth, 
        timeout: '180000',
      },
      observe: 'body',
      reportProgress: true
    });
  }

  getFile<T>(url: string, body: any, auth = 'Basic'): Observable<T> {
    return this.httpClient.post<T>(url, body, {
      headers: { Authorization: auth },
      responseType: 'blob' as 'json',
      reportProgress: true
    });
  }

  // getFile<T>(url: string, auth = 'Basic'): Observable<T> {
  //   return this.httpClient.post<T>(url, {
  //     headers: {Authorization: auth},
  //     //observe: 'body',
  //     //responseType: 'arraybuffer' as const
  //   });
  // }

  // exportFile<T>(url: string, auth = 'Basic'): Observable<T> {
  //   return this.httpClient.post<T>(url, {
  //     headers: {Authorization: auth},
  //     responseType: 'blob' as 'json',
  //     reportProgress: true
  //   });
  // }

  exportFile<T>(url: string, body: any, auth = 'Basic'): Observable<T> {
    return this.httpClient.post<T>(url, body, {
      headers: { Authorization: auth, timeout: '180000' },
      // observe: 'body',
      responseType: 'blob' as 'json',
      reportProgress: true
    });
  }

  andxorGetFile<T>(url: string, username, password): Observable<T> {
    return this.httpClient.get<T>(url, {
      headers: {
        'Authorization': 'Basic ' + btoa(username + ":" + password),
      },
      responseType: 'blob' as 'json',
    })
  }

  andxorDownloadZip<T>(url: string, body, username, password): Observable<T> {
    return this.httpClient.post<T>(url, body, {
      headers: {
        'Authorization': 'Basic ' + btoa(username + ":" + password),
      },
      responseType: 'blob' as 'json',

    })
  }

  andxorGet<T>(url: string, username, password): Observable<T> {
    return this.httpClient.get<T>(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + btoa(username + ":" + password)
      }
    })
  }


  andxorPost<T>(url: string, body: any, username, password): Observable<T> {
    return this.httpClient.post<T>(url, body, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + btoa(username + ":" + password),
      },
      observe: 'body',
      reportProgress: true
    });
  }

  getAuthHeaders(auth: string) {
    return { headers: { Authorization: auth, 'Content-Type': ('application/json') } };
  }
}
